import { render, staticRenderFns } from "./WalkingTravelDetail.vue?vue&type=template&id=476464ce"
import script from "./WalkingTravelDetail.vue?vue&type=script&lang=js"
export * from "./WalkingTravelDetail.vue?vue&type=script&lang=js"
import style0 from "./WalkingTravelDetail.vue?vue&type=style&index=0&id=476464ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports